/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
/**
 * Check if a given object implements the StaffDuplicateFileDto interface.
 */
export function instanceOfStaffDuplicateFileDto(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffDuplicateFileDtoFromJSON(json) {
    return StaffDuplicateFileDtoFromJSONTyped(json, false);
}
export function StaffDuplicateFileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'sameUploader': !exists(json, 'sameUploader') ? undefined : json['sameUploader'],
        'reportModerationStatus': !exists(json, 'reportModerationStatus') ? undefined : ModerationStatusFromJSON(json['reportModerationStatus']),
        'uploadedAt': !exists(json, 'uploadedAt') ? undefined : (new Date(json['uploadedAt'])),
    };
}
export function StaffDuplicateFileDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileId': value.fileId,
        'incidentReportId': value.incidentReportId,
        'sameUploader': value.sameUploader,
        'reportModerationStatus': ModerationStatusToJSON(value.reportModerationStatus),
        'uploadedAt': value.uploadedAt === undefined ? undefined : (value.uploadedAt.toISOString()),
    };
}
